import FiscalDocsProviderTypeEnum from '@/api/Enums/FiscalDocsProviderTypeEnum'
import FiscalDocTypeEnum from '@/api/Enums/FiscalDocTypeEnum'
import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum'
import TransactionsCommon from '@/mixins/payments/transactionsCommon.js'
import PaymentType from '@/mixins/orders/paymentType.js'

export default {
  mixins  : [TransactionsCommon, PaymentType],
  computed: {
    totalOrderValue() {
      const orderTotal = parseFloat(this.orderTotal?.toFixed(2))
      const tableTotal = parseFloat(this.tableTotal?.toFixed(2))
      const tableUnpaidTotal = parseFloat(this.tableUnpaidTotalForPayment?.toFixed(2))

      if (orderTotal) return orderTotal
      if (tableTotal) return tableTotal
      if (tableUnpaidTotal) return tableUnpaidTotal

      return 0
    },

    hasCashTransaction() {
      return !!this.transactions?.some(payment => payment.PaymentType === PaymentTypeEnum.CASH)
    },

    hasNoSelfDeliveryTransaction() {
      return !!this.transactions?.some(payment => !PaymentTypeEnum.isSelfDelivery(payment.PaymentType))
    },

    hasAnyTransaction() {
      return this.transactions?.length > 0
    },

    cashTransactionAllowed() {
      return this.isValidAmountForCashPayment
    },

    isValidAmountForSelfDeliveryReceipt() {
      return this.totalOrderValue > this.minSelfDeliveryPaymentAmount
    },

    isValidAmountForCashPayment() {
      if (!this.domainReceiptsActive) return true

      return this.totalOrderValue < this.maxCashPaymentAmount || this.selectedFiscalDocType === FiscalDocTypeEnum.NONE
    },

    isValidAmountForCashPaymentWithReceipt() {
      if (!this.domainReceiptsActive) return true

      return this.totalOrderValue < this.maxCashPaymentAmount || this.selectedPaymentType !== PaymentTypeEnum.CASH
    },

    hasCardPaymentsThatRequireReceipt() {
      if (!this.domainReceiptsActive) return false

      return !!this.transactions?.some(transaction => (PaymentTypeEnum.requiresFiscalDocument(transaction.PaymentType) && this.eftPosCardTransactionPaidSuccessful(transaction)))
    },

    receiptDocumentDisabled() {
      if (!this.domainReceiptsActive) return false

      return !this.isValidAmountForCashPaymentWithReceipt
        || !this.appFiscalDocsProviderDocument.includes(FiscalDocTypeEnum.RECEIPT)
        || (this.hasCardPaymentsThatRequireReceipt && !FiscalDocTypeEnum.isReceipt(this.selectedFiscalDocType))
    },

    invoiceDocumentDisabled() {
      if (!this.domainReceiptsActive) return false

      return !this.isValidAmountForCashPaymentWithReceipt
        || !this.appFiscalDocsProviderDocument.includes(FiscalDocTypeEnum.INVOICE)
        || (this.hasCardPaymentsThatRequireReceipt && !FiscalDocTypeEnum.isInvoice(this.selectedFiscalDocType))
    },

    noFiscalDocumentDisabled() {
      if (!this.domainReceiptsActive) return false

      return !!this.transactions?.some(transaction => PaymentTypeEnum.requiresFiscalDocument(transaction.PaymentType))
    },

    domainReceiptsActive() {
      return this.appHasFiscalDocsEnabled && this.appHasFiscalDocsProvider && this.appFiscalDocsProviderType === FiscalDocsProviderTypeEnum.CLOUD
    }
  },
  methods: {
    setSelectedPaymentType(val) {
      if (!this.paymentTypesActive?.find(payment => payment.code === val)) return

      this.selectedPaymentType = val
      this.checkCashPaymentsAllowed()
    },

    checkDocumentTypeAllowed() {
      if (!this.domainReceiptsActive) return

      if (this.receiptDocumentDisabled && FiscalDocTypeEnum.isReceipt(this.selectedFiscalDocType)) this.selectedFiscalDocType = null

      if (this.invoiceDocumentDisabled && FiscalDocTypeEnum.isInvoice(this.selectedFiscalDocType)) this.selectedFiscalDocType = null

      if (this.noFiscalDocumentDisabled && this.selectedFiscalDocType === FiscalDocTypeEnum.NONE) this.selectedFiscalDocType = null
    },

    checkCashPaymentsAllowed() {
      if (!this.isValidAmountForCashPayment && this.selectedPaymentType === PaymentTypeEnum.CASH) {
        //this.selectedPaymentType = null
      }

      this.checkDocumentTypeAllowed()
    }
  }
}
